// extracted by mini-css-extract-plugin
export default {"btnStyles":"Button_btnStyles__eV76z","container":"Button_container__K9X6Y"};